export default __webpack_public_path__ + "static/media/completion-report.0df80cf4.svg";